import convertDisplayName from '../ApiResponseServices/convertDisplayName';

const processApiResponseData = (data) => {
  const rawData = data.apiResponseTimes;

  const serviceType = (rawData[0] !== undefined ? rawData[0].servertype : null);
  let totalRequests = 0;
  const apiMethods = [];
  let statusKeys = [];
  let apiTuple = {};
  let tempLineTuple = {};
  let tempBarTuple = {};
  let tempTuple = {};
  let key = '';
  let x;
  let y = '';

  const newData = {
    serviceType,
    serviceDisplay: convertDisplayName(serviceType),
    data: [],
  };

  // for (const prop in rawData) {
  Object.keys(rawData).forEach((prop) => {
    if (rawData[prop] !== undefined) {
      const currApiMethod = rawData[prop].apimethod;

      if (!apiMethods.includes(currApiMethod)) {
        apiMethods.push(currApiMethod);
        totalRequests = rawData[prop].totalrequest;
        apiTuple = {
          apiMethod: currApiMethod,
          totalrequest: totalRequests,
          lineChartData: [],
          barChartData: [],
          keys: [],
        };

        if (rawData[prop].percentiles !== undefined && rawData[prop].percentiles !== null) {
          Object.keys(rawData[prop].percentiles).forEach((n) => {
            if (rawData[prop].percentiles[n] !== undefined) {
              if (rawData[prop].percentiles[n].percentile === 50) {
                key = 'P50';
              } else if (rawData[prop].percentiles[n].percentile === 95) {
                key = 'P95';
              } else if (rawData[prop].percentiles[n].percentile === 99) {
                key = 'P99';
              }
              x = rawData[prop].time_bucket;
              y = rawData[prop].percentiles[n].value;
              tempTuple = { x, y };

              tempLineTuple = { id: key, data: [] };
              tempLineTuple.data.push(tempTuple);
              apiTuple.lineChartData.push(tempLineTuple);
            }
          });
        } else {
          x = rawData[prop].time_bucket;
          y = 0;
          tempTuple = { x, y };

          tempLineTuple = { id: 'P50', data: [] };
          tempLineTuple.data.push(tempTuple);
          apiTuple.lineChartData.push(tempLineTuple);

          tempLineTuple = { id: 'P95', data: [] };
          tempLineTuple.data.push(tempTuple);
          apiTuple.lineChartData.push(tempLineTuple);

          tempLineTuple = { id: 'P99', data: [] };
          tempLineTuple.data.push(tempTuple);
          apiTuple.lineChartData.push(tempLineTuple);
        }
        tempTuple = {};

        tempBarTuple = { time_bucket: rawData[prop].time_bucket };
        Object.keys(rawData[prop].status_counts).forEach((m) => {
          if (rawData[prop].status_counts[m] !== undefined) {
            const statusKey = rawData[prop].status_counts[m].status_code;
            if (!statusKeys.includes(statusKey)) {
              statusKeys.push(statusKey);
            }
            x = rawData[prop].time_bucket;
            y = rawData[prop].status_counts[m].status_count;
            tempTuple[statusKey] = y;
            tempBarTuple = Object.assign(tempTuple, tempBarTuple);
            tempTuple = {};
          }
        });
        apiTuple.barChartData.push(tempBarTuple);
        apiTuple.keys = statusKeys;

        newData.data.push(apiTuple);
        tempTuple = {};
        tempLineTuple = {};
        apiTuple = {};
        statusKeys = [];
        key = '';
      } else {
        Object.keys(newData.data).forEach((index) => {
          if (newData.data[index] !== undefined) {
            if (newData.data[index].apiMethod === currApiMethod) {
              totalRequests = newData.data[index].totalrequest + rawData[prop].totalrequest;
              newData.data[index].totalrequest = totalRequests;

              // for (const n in rawData[prop].percentiles) {
              if (rawData[prop].percentiles !== undefined && rawData[prop].percentiles !== null) {
                Object.keys(rawData[prop].percentiles).forEach((n) => {
                  if (rawData[prop].percentiles[n] !== undefined) {
                    if (rawData[prop].percentiles[n].percentile === 50) {
                      key = 'P50';
                    } else if (rawData[prop].percentiles[n].percentile === 95) {
                      key = 'P95';
                    } else if (rawData[prop].percentiles[n].percentile === 99) {
                      key = 'P99';
                    }
                    x = rawData[prop].time_bucket;
                    y = rawData[prop].percentiles[n].value;
                    tempTuple = { x, y };

                    Object.keys(newData.data[index].lineChartData).forEach((m) => {
                      if (newData.data[index].lineChartData[m] !== undefined) {
                        if (newData.data[index].lineChartData[m].id === key) {
                          newData.data[index].lineChartData[m].data.push(tempTuple);
                        }
                      }
                    });
                    tempTuple = {};
                    key = '';
                  }
                });
              } else {
                x = rawData[prop].time_bucket;
                y = 0;
                tempTuple = { x, y };

                Object.keys(newData.data[index].lineChartData).forEach((m) => {
                  if (newData.data[index].lineChartData[m] !== undefined) {
                    if (newData.data[index].lineChartData[m].id === 'P50') {
                      newData.data[index].lineChartData[m].data.push(tempTuple);
                    }
                  }
                });

                Object.keys(newData.data[index].lineChartData).forEach((m) => {
                  if (newData.data[index].lineChartData[m] !== undefined) {
                    if (newData.data[index].lineChartData[m].id === 'P95') {
                      newData.data[index].lineChartData[m].data.push(tempTuple);
                    }
                  }
                });

                Object.keys(newData.data[index].lineChartData).forEach((m) => {
                  if (newData.data[index].lineChartData[m] !== undefined) {
                    if (newData.data[index].lineChartData[m].id === 'P99') {
                      newData.data[index].lineChartData[m].data.push(tempTuple);
                    }
                  }
                });
              }
              tempTuple = {};

              tempBarTuple = { time_bucket: rawData[prop].time_bucket };
              Object.keys(rawData[prop].status_counts).forEach((m) => {
                if (rawData[prop].status_counts[m] !== undefined) {
                  const statusKey = rawData[prop].status_counts[m].status_code;
                  statusKeys = newData.data[index].keys;
                  if (!statusKeys.includes(statusKey)) {
                    statusKeys.push(statusKey);
                  }
                  x = rawData[prop].time_bucket;
                  y = rawData[prop].status_counts[m].status_count;
                  tempTuple[statusKey] = y;
                  tempBarTuple = Object.assign(tempTuple, tempBarTuple);
                  tempTuple = {};
                }
              });
              newData.data[index].barChartData.push(tempBarTuple);
            }
          }
        });
      }
    }
  });

  return newData;
};

export default processApiResponseData;
